import { Button, Dropdown, Menu } from 'antd';
import React, { Dispatch, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import TitlePage from '../../../../components/TitlePage';
import { ApplicationState } from '../../../../store';
import { loadRequest } from '../../../../store/ducks/agendamentos/actions';
import Filter from './components/Filter';
import {
  EllipsisOutlined,
  PrinterOutlined,
  FilterOutlined,
} from '@ant-design/icons';
import { Container, ContFilter } from './styles';
import { ColumnType } from 'antd/lib/table';
import { Sorter, sorterParamsHandle } from '../../../../utils/sorte';
import TableSort from '../../../../components/TableSort';
import mask from '../../../../utils/mask';
import iconcoleta from '../../../../assets/img/coleta.svg';
import iconentrega from '../../../../assets/img/entrega.svg';
import ModalDetalhesMotorista from './components/Modal/ModalDetalhesMotorista';
import { useWindowSize } from '../../../../hook/useWindowSize';
import CardMobile from './components/CardMobile';
import ModalCancelarPedido from './components/Modal/ModalCancelarPedido';
import ModalEditarPedido from './components/Modal/ModalEditarPedido';
import { SKW_PREFIX } from '../../../../utils/constants';
import api from '../../../../service/api';
import { saveAs } from 'file-saver';
import GetStatus from '../../../../components/GetStatus';
import moment from 'moment';
import ModalDetalhesVeiculo from '../../../../components/ModalDetalhesVeiculo';
import TextTable from '../../../../components/TextTable';
import Refresh from '../../../../components/Refresh';
import { IAgendamentos } from '../../../../store/ducks/agendamentos/types';
import TitleTable from 'components/TitleTable';
import { TableSec } from '../../../../components/_REFACTORED/SecondaryTable';
import { Export } from './components/Export';

const Agendamentos: React.FC = () => {
  const dispatch = useDispatch<Dispatch<Action>>();
  const { width }: any = useWindowSize();
  const pagination = useSelector((state: ApplicationState) => state.Agendamentos.pagination);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const agendamentos = useSelector((state: ApplicationState) => state.Agendamentos.data);
  const loading = useSelector((state: ApplicationState) => state.Agendamentos.loading);
  const filter = useSelector((state: ApplicationState) => state.Agendamentos.filter);
  const token: string = useSelector((state: ApplicationState) => state.auth.token);
  const [filterActive, setFilterActive] = useState<string[]>([]);

  useEffect(() => {
    setFilterActive(Object.keys(filter ?? {}));
  }, [filter]);

  const columns: ColumnType<IAgendamentos>[] = [
    {
      title: <TitleTable>Tipo WMS</TitleTable>,
      dataIndex: 'tipoWms',
      key: 'tipoWms',
      align: 'center',
      width: 120,

      render: (text, record) => {
        const data =
          text === 'EXP' ? (
            <TextTable>
              Coleta
              <img
                width="10px"
                src={iconcoleta}
                alt="Saída"
                title="Saída"
                style={{ marginLeft: '10px' }}
              />
            </TextTable>
          ) : (
            <TextTable>
              Entrega{' '}
              <img
                width="10px"
                src={iconentrega}
                alt="Entrada"
                title="Entrada"
                style={{ marginLeft: '10px' }}
              />
            </TextTable>
          );

        return (
          <>
            <span style={{ opacity: record.status === 'CAN' ? 0.5 : 1 }}>{data}</span>
          </>
        );
      },
    },
    {
      title: <TitleTable>Agendamento</TitleTable>,
      dataIndex: 'codAgendamento',
      key: 'codAgendamento',
      align: 'center',
      width: 150,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 14,
      },
      render: (text, record) => {
        return text ? (
          <span style={{ opacity: record.status === 'CAN' ? 0.5 : 1 }}>
            <TextTable>{text}</TextTable>{' '}
          </span>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Status</TitleTable>,
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      width: 300,
      sorter: {
        compare: Sorter.STRING,
        multiple: 7,
      },
      render: (text, record) => {
        return (
          <span style={{ opacity: record.status === 'CAN' ? 0.5 : 1 }}>
            <GetStatus acronym={text} />
          </span>
        );
      },
    },
    {
      title: <TitleTable>Data</TitleTable>,
      dataIndex: 'dhAgendamento',
      key: 'dhAgendamento',
      align: 'center',
      width: 220,
      sorter: {
        compare: Sorter.STRING,
        multiple: 1,
      },
      render: (text, record) => {
        return text ? (
          <span style={{ opacity: record.status === 'CAN' ? 0.5 : 1 }}>
            <TextTable>{moment(text).format('LLL')}</TextTable>
          </span>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Ordem de carga</TitleTable>,
      dataIndex: 'ordemCarga',
      key: 'ordemCarga',
      align: 'center',
      width: 180,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 6,
      },
      render: (text, record) => {
        return text ? (
          <span style={{ opacity: record.status === 'CAN' ? 0.5 : 1 }}>
            <TextTable>{text}</TextTable>
          </span>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Centro distribuição</TitleTable>,
      dataIndex: 'centroDistribuicao',
      key: 'centroDistribuicao',
      align: 'center',
      width: 300,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 2,
      },
      render: (text: string, record) => {
        return text ? (
          <span style={{ opacity: record.status === 'CAN' ? 0.5 : 1 }}>
            <TextTable>{mask('camelCase', text)}</TextTable>
          </span>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Cliente</TitleTable>,
      dataIndex: 'cliente',
      key: 'cliente',
      align: 'center',
      width: 300,
      sorter: {
        compare: Sorter.STRING,
        multiple: 3,
      },
      render: (text: string, record) => {
        return text ? (
          <span style={{ opacity: record.status === 'CAN' ? 0.5 : 1 }}>
            {' '}
            <TextTable>{mask('camelCase', text)}</TextTable>
          </span>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Transportadora</TitleTable>,
      dataIndex: 'transportadora',
      key: 'transportadora',
      align: 'center',
      width: 300,
      sorter: {
        compare: Sorter.STRING,
        multiple: 4,
      },
      render: (text: string, record) => {
        return text ? (
          <span style={{ opacity: record.status === 'CAN' ? 0.5 : 1 }}>
            <TextTable>{mask('transportadoraUf', text)}</TextTable>
          </span>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Motorista</TitleTable>,
      dataIndex: 'motorista',
      key: 'motorista',
      align: 'center',
      width: 250,
      sorter: {
        compare: Sorter.STRING,
        multiple: 8,
      },
      render: (text, record) => {
        return record.detalheMotorista ? (
          <span style={{ opacity: record.status === 'CAN' ? 0.5 : 1 }}>
            {' '}
            <ModalDetalhesMotorista motorista={record.detalheMotorista}>
              {mask('camelCase', text)}
            </ModalDetalhesMotorista>
          </span>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Placa</TitleTable>,
      dataIndex: 'placa',
      key: 'placa',
      align: 'center',
      width: 150,
      sorter: {
        compare: Sorter.STRING,
        multiple: 9,
      },
      render: (text, record) => {
        return record.detalheVeiculo ? (
          <span style={{ opacity: record.status === 'CAN' ? 0.5 : 1 }}>
            <ModalDetalhesVeiculo veiculo={record.detalheVeiculo}>
              {text?.toUpperCase()}
            </ModalDetalhesVeiculo>
          </span>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Peso bruto</TitleTable>,
      dataIndex: 'pesoBruto',
      key: 'pesoBruto',
      align: 'center',
      width: 180,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 10,
      },
      render: (text, record) => {
        return text ? (
          <span style={{ opacity: record.status === 'CAN' ? 0.5 : 1 }}>
            <TextTable>{mask('peso', text)}</TextTable>
          </span>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Valor total</TitleTable>,
      dataIndex: 'valor',
      key: 'valor',
      align: 'center',
      width: 200,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 11,
      },
      render: (text: string, record) => {
        return text ? (
          <span style={{ opacity: record.status === 'CAN' ? 0.5 : 1 }}>
            <TextTable>{mask('currency', text)}</TextTable>
          </span>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Ação</TitleTable>,
      dataIndex: 'acao',
      key: 'acao',
      fixed: 'right',
      width: 100,
      render: (text, record) => {
        return (
          <Dropdown
            disabled={record.status === 'CAN'}
            overlay={
              <Menu>
                <Menu.Item onClick={() => handlePdf(record)} className="themeButomAgendamento">
                  <Button
                    type="text"
                    block
                    className="primary"
                    icon={<PrinterOutlined />}
                    style={{ display: 'block', width: '100%', border: '1px solid #DDD' }}
                  >
                    Imprimir
                  </Button>
                </Menu.Item>

                <Menu.Item className="themeButomAgendamento">
                  <ModalEditarPedido record={record} />
                </Menu.Item>

                <Menu.Item className="themeButomAgendamento">
                  <ModalCancelarPedido record={record} />
                </Menu.Item>

              </Menu>
            }
          >
            <Button type="link" className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
              <EllipsisOutlined
                style={{ fontSize: '30px', transform: 'rotate(90deg)', color: '#3c6ab4' }}
              />
            </Button>
          </Dropdown>
        );
      },
    },
  ];

  const handlePdf = (value: any) => {
    api
      .get(
        `/call?serviceName=${SKW_PREFIX}imprimeAgendamento&token=${token}&agendamento=${value.codAgendamento}`,
        {
          responseType: 'arraybuffer',
        }
      )
      .then((res) => {
        const blob = new Blob([res.data], { type: 'application/pdf' });
        saveAs(blob, `Agendamento_${value.codAgendamento}.pdf`);
      });
  };

  return (
    <>
      <Refresh
        loadRequest={() =>
          dispatch(loadRequest(filter, inscricaoAtiva, cddAtivo?.codCdd, pagination))
        }
      />
      <Filter />

      <Container>
        <TitlePage>
          <span>
            Agendamentos
          </span>

          {filterActive.length > 0 && (
            <ContFilter>
              {filterActive.map((item) => (
                <p key={item}>
                  {item === 'tipoWms' && (
                    <>
                      <FilterOutlined /> Tipo WMS
                    </>
                  )}
                  {item === 'codAgendamento' && (
                    <>
                      <FilterOutlined />
                      N° Agendamento
                    </>
                  )}
                  {item === 'ordemCarga' && (
                    <>
                      <FilterOutlined />
                      N° Ordem de carga
                    </>
                  )}
                  {item === 'status' && (
                    <>
                      <FilterOutlined />
                      Status
                    </>
                  )}
                  {item === 'codParceiro' && (
                    <>
                      <FilterOutlined />
                      Parceiro
                    </>
                  )}
                  {item === 'codTransportadora' && (
                    <>
                      <FilterOutlined />
                      Transportadora
                    </>
                  )}
                  {item === 'placa' && (
                    <>
                      <FilterOutlined />
                      Placa
                    </>
                  )}

                  {item === 'dhAgendamento' && (
                    <>
                      <FilterOutlined />
                      Data
                    </>
                  )}
                </p>
              ))}
            </ContFilter>
          )}
          <div className="box">
            <Export />
          </div>
        </TitlePage>

        {width > 768 && (
          <TableSort
            style={{ fontSize: 10, display: 'inline' }}
            columns={columns}
            scroll={{ x: 2600 }}
            size={'large'}
            rowKey={(record: any, index: number) => index.toString()}
            onChange={(pagination: any, filters: any, sorter: any) => {
              dispatch(
                loadRequest(
                  filter,
                  inscricaoAtiva,
                  cddAtivo?.codCdd,
                  pagination,
                  sorterParamsHandle(sorter)
                )
              );
            }}
            loading={loading}
            pagination={pagination}
            className="table"
            dataSource={agendamentos}
            expandable={{
              expandedRowRender: (record: any) => {
                return (
                  <span style={{ opacity: record.status === 'CAN' ? 0.5 : 1 }}>
                    <TableSec ordemCarga={record.ordemCarga} codEmp={record.codEmp} />
                  </span>
                );
              },
            }}
          />
        )}
        {width <= 768 && (
          <CardMobile
            props={agendamentos}
            pagination={pagination}
            loading={loading}
            inscricaoAtiva={inscricaoAtiva}
            cddAtivo={cddAtivo}
            filter={filter}
          />
        )}
      </Container>
    </>
  );
};

export default Agendamentos;
